import { render, staticRenderFns } from "./IconProjectType.vue?vue&type=template&id=2240710a&"
import script from "./IconProjectType.vue?vue&type=script&lang=js&"
export * from "./IconProjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports